import { VehicleFuelType } from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";
import { useTranslation } from "react-i18next";
import { Icon } from "@/shared/ui";
import { GasStationState } from "@/domains/gasStation/slice";
import GasStationFuelTank from "@/domains/gasStation/components/GasStationFuelTank";
import GasStationCarStand from "@/domains/gasStation/components/GasStationVehicleStand.tsx";

export default function GasStationVehicleInfo({
  brand,
  model,
  fuelAmount,
  fuelMaxAmount,
  fuelType,
  brandImage,
  modelImage,
}: GasStationState["vehicle"]) {
  const { t } = useTranslation("gasStation");
  const fuelPercent =
    fuelMaxAmount === 0 ? 0 : Number(((fuelAmount / fuelMaxAmount) * 100).toFixed(0));

  const isElectric = fuelType === VehicleFuelType.Electric;

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center gap-2.5">
        <img src={brandImage} alt="" className="h-[2.625rem]" />
        <div>
          <div className="text-17 font-bold text-white">
            {brand} {model}
          </div>
          <div className="text-15 font-medium text-white/60">
            {isElectric ? (
              t("gasStation.electricTransport")
            ) : (
              <>
                {t("gasStation.fuelCondintion")}:{" "}
                <span className="text-accent">{fuelPercent}%</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="flex items-end">
        <div className="grow flex flex-col gap-7">
          <div className="relative">
            <img src={modelImage} alt="" className="absolute w-[16.25rem] h-[9.1875rem] bottom-1" />
            <GasStationCarStand />
          </div>
          <div className="flex items-center gap-2">
            <Icon category="speedometer" name="fuel" className="w-6 shrink-0" />
            <div className="text-15 text-white/60 font-medium">
              {isElectric ? (
                <>
                  {t("gasStation.typeFuel")}: <span className="text-white">Electro</span>
                </>
              ) : (
                <>
                  {t("gasStation.recommendedFuel")}:{" "}
                  <span className="text-white">
                    {fuelType ? t(`gasStation.fuelType.${fuelType.toLocaleLowerCase()}`) : "-"}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
        <GasStationFuelTank
          isElectric={isElectric}
          fuel={fuelAmount}
          fuelCapacity={fuelMaxAmount}
        />
      </div>
    </div>
  );
}
